import { render } from "./UpdateFolderModal.vue?vue&type=template&id=3b90ac95&scoped=true&ts=true"
import script from "./UpdateFolderModal.vue?vue&type=script&lang=ts"
export * from "./UpdateFolderModal.vue?vue&type=script&lang=ts"

import "./UpdateFolderModal.vue?vue&type=style&index=0&id=3b90ac95&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b90ac95"]])

export default __exports__